export default __webpack_public_path__ + "static/media/logo-softphone.b0117965.png";